import { useEffect, useState } from 'react';
import type { ContactMessage } from '../../shared/types';

export default function MessageList() {
  const [messages, setMessages] = useState<ContactMessage[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const response = await fetch('/api/messages');
        const data = await response.json();
        
        if (!response.ok) {
          throw new Error(data.error || 'Failed to fetch messages');
        }

        setMessages(data.messages);
      } catch (error) {
        console.error('Error fetching messages:', error);
        setError(error instanceof Error ? error.message : 'Failed to fetch messages');
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, []);

  if (loading) {
    return <div className="mt-8 text-center text-white/60">Loading messages...</div>;
  }

  if (error) {
    return <div className="mt-8 text-center text-red-500">{error}</div>;
  }

  if (!messages.length) {
    return <div className="mt-8 text-center text-white/60">No messages yet</div>;
  }

  return (
    <div className="mt-12">
      <h2 className="text-2xl font-semibold mb-6">Recent Messages</h2>
      <div className="space-y-4">
        {messages.map((message) => (
          <div key={message.id} className="bg-zinc-800/30 border border-white/10 p-4 rounded-lg">
            <div className="flex justify-between items-start mb-2">
              <div>
                <h3 className="font-medium">{message.name}</h3>
                <p className="text-sm text-white/60">{message.email}</p>
              </div>
              <time className="text-sm text-white/40">
                {new Date(message.created_at).toLocaleDateString()}
              </time>
            </div>
            <p className="text-white/80">{message.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
} 